/** @jsx jsx */
import { jsx } from '@theme-ui/core';

type InputLabelProps = {
    text: React.ReactNode;
    inputId?: string;
};

export const InputLabel = ({ text, inputId }: InputLabelProps) => (
    <label
        htmlFor={inputId}
        sx={{
            display: 'block',
            marginBottom: 1,
            variant: 'text.description',
            fontSize: 1,
        }}
    >
        {text}
    </label>
);
